type Props = {
  title: string;
  hint?: string;
};

export function MobileEmpty({ title, hint }: Props) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-2 p-8 text-center">
      <p className="text-sm font-medium text-[var(--mail-text)]">{title}</p>
      {hint ? <p className="text-xs text-[var(--mail-muted)]">{hint}</p> : null}
    </div>
  );
}
